import { types, actions } from './requests'
export const DELETEARTICLE_TYPES = {
    ...types('DELETEARTICLE'),
}
export const DELETEARTICLE_ACTIONS = {
    ...actions('DELETEARTICLE'),
}
